// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__wS-Id","content":"styles_content__3pCPH","checkbox":"styles_checkbox__2hmpY","checkboxLabel":"styles_checkboxLabel__1_bnC"};